import React, { useEffect, useRef } from "react";

function useReveal() {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) e.target.classList.add("in-view");
                });
            },
            { threshold: 0.15 }
        );
        el.querySelectorAll(".fade-up").forEach((n) => io.observe(n));
        return () => io.disconnect();
    }, []);
    return ref;
}

export default function About() {
    const ref = useReveal();
    return (
        <section
            id="ueber-uns"
            ref={ref}
            data-testid="about-section"
            className="relative bg-[#FEFEFE] py-28 lg:py-40"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
                    <div className="lg:col-span-5">
                        <div className="eyebrow fade-up mb-6">Über uns</div>
                        <h2
                            className="fade-up text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#14100D] leading-[1.02]"
                            style={{ fontFamily: "Outfit, sans-serif" }}
                        >
                            Handwerk, das <span className="font-medium">bleibt.</span>
                        </h2>
                    </div>

                    <div className="lg:col-span-6 lg:col-start-7">
                        <p className="fade-up text-[17px] lg:text-[19px] leading-relaxed text-[#14100D]/80 max-w-xl">
                            CLER BAU AG steht für sauberes Maurerhandwerk, verlässliche Ausführung und den ruhigen Anspruch, jedes Detail zu beherrschen. Wir bauen nicht in Massen, wir bauen in Qualität.
                        </p>
                        <p className="fade-up mt-6 text-[15px] lg:text-[17px] leading-relaxed text-[#14100D]/70 max-w-xl">
                            Von der ersten Skizze bis zum letzten Fugenstrich begleiten wir jedes Projekt persönlich – mit einem kleinen, eingespielten Team und einem klaren Wort für unsere Kunden.
                        </p>

                        <div className="fade-up mt-12 grid grid-cols-3 gap-6 max-w-lg">
                            <Stat value="100%" label="Handwerk aus der Schweiz" />
                            <Stat value="A–Z" label="Betreuung aus einer Hand" />
                            <Stat value="98%" label="Termintreue" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Stat({ value, label }) {
    return (
        <div>
            <div
                className="text-3xl lg:text-4xl font-medium text-[#14100D]"
                style={{ fontFamily: "Outfit, sans-serif" }}
            >
                {value}
            </div>
            <div className="mt-2 h-px w-8 bg-[#E20514]" />
            <div className="mt-3 text-[11px] tracking-[0.2em] uppercase text-[#14100D]/60">
                {label}
            </div>
        </div>
    );
}
